<template>
  <div>
    <KCglpage />
  </div>
</template>

<script>
// 获取接口地址
import KCglpage from '@/components/Kcgl/KCglpage'

export default {
  name: 'Kcgl',
  components: {
    // sideMenu,
    // Header,
    KCglpage
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
